export type FormatSignedNumberOptions = {
  prefix?: string;
  suffix?: string;
  decimalPlaces?: number;
  showZeroWithSign?: boolean;
  showPositiveSign?: boolean;
};

const japaneseNumberFormatter = new Intl.NumberFormat("ja-JP");

export const formatSignedNumber = (
  value: number,
  {
    prefix = "",
    suffix = "",
    decimalPlaces,
    showZeroWithSign = false,
    showPositiveSign = true,
  }: FormatSignedNumberOptions = {},
) => {
  const normalizedDecimalPlaces =
    decimalPlaces === undefined
      ? undefined
      : Math.min(20, Math.max(0, Math.trunc(decimalPlaces)));
  const formatter =
    normalizedDecimalPlaces === undefined
      ? japaneseNumberFormatter
      : new Intl.NumberFormat("ja-JP", {
          minimumFractionDigits: normalizedDecimalPlaces,
          maximumFractionDigits: normalizedDecimalPlaces,
        });
  const formattedValue = formatter.format(Math.abs(value));
  const label =
    value < 0
      ? `\u25B2${formattedValue}`
      : showPositiveSign
      ? value > 0 || showZeroWithSign
        ? `+${formattedValue}`
        : "+"
      : formattedValue;

  return `${prefix}${label}${suffix}`;
};

export default formatSignedNumber;
